<template>
  <section>
    <mdb-row>
      <mdb-col md="12">
        <mdb-card cascade narrow class="mt-5">
          <mdb-view class="gradient-card-header elegant-color-dark">
            <h4 class="h4-responsive text-white">
              {{ farmData.name }} Detail
            </h4>
          </mdb-view>
          <mdb-card-body>
            <validated-form :message="formMessage" @submit="handleFormSubmit">
              <mdb-input
                v-model="farmData.name"
                size="lg"
                label="Farm Name"
                type="text"
                validate
                outline
                required
              />
              <mdb-input
                v-model="farmData.address"
                size="lg"
                label="Address"
                type="text"
                validate
                outline
              />
              <mdb-row>
                <mdb-col>
                  <mdb-input
                    v-model="farmData.city"
                    size="lg"
                    label="City"
                    type="text"
                    validate
                    outline
                  />
                </mdb-col>
                <mdb-col>
                  <div class="form-group">
                    <label>State</label>
                    <multiselect
                      v-model="farmData.state"
                      tag-placeholder="Select a State"
                      placeholder="Select a State"
                      :options="states"
                    />
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-input
                v-model="farmData.postalCode"
                size="lg"
                label="Postal Code"
                type="text"
                validate
                outline
              />
              <div class="form-check">
                <input
                  id="isActiveCheckbox"
                  v-model="farmData.isActive"
                  type="checkbox"
                  class="form-check-input"
                />
                <label class="form-check-label pl-2" for="isActiveCheckbox">
                  Is Active?
                </label>
              </div>
              <mdb-btn color="primary" type="submit" class="float-right">
                Save
              </mdb-btn>
            </validated-form>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </section>
</template>

<script>
import {
  mdbRow,
  mdbCard,
  mdbCardBody,
  mdbCol,
  mdbView,
  mdbInput,
  mdbBtn
} from "mdbvue";
import Multiselect from "vue-multiselect";
import ValidatedForm from "./ValidatedForm";
import { farmsModel } from "../models/farm";
import { mapService } from "../services/map.service";

export default {
  name: "FarmDetailForm",
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbView,
    mdbInput,
    mdbBtn,
    Multiselect,
    ValidatedForm
  },
  props: {
    farmId: {
      type: String,
      default: ""
    },
    farmData: {
      type: Object,
      default: function() {
        return {
          id: "",
          name: "",
          address: "",
          city: "",
          state: "",
          postalCode: "",
          isActive: true,
          updatedAt: "",
          createdAt: "",
          createdBy: ""
        };
      }
    }
  },
  data() {
    return {
      states: mapService.getUSStates(),
      formMessage: {},
      fieldFormModal: false
    };
  },
  methods: {
    handleFormSubmit() {
      this.formMessage = {};
      const data = this.farmData;
      return farmsModel
        .update(this.farmId, data)
        .then(() => {
          this.formMessage = {
            type: "success",
            message: "Farm Saved!"
          };
          this.$emit("savedFarm");
        })
        .catch(error => {
          console.log(error);
          this.formMessage = {
            type: "danger",
            message: "There was a problem updating. Please try again"
          };
        });
    }
  }
};
</script>
